import SVG from '@app/components/SVG';
import styled from '@emotion/styled';
import { observer } from 'mobx-react';
import React, { FC } from 'react';
import TransferIcon from '@app/images/transfer.svg';
import EnvelopeIcon from '@app/images/envelope.svg';
import { useTranslation } from 'react-i18next';

const FrictionlessAfterFormSpecialComponent: FC<{ step1: string; step2: string; withFieldInstructions: boolean }> = observer(
  ({ step1, step2, withFieldInstructions = false }) => {
    const { t } = useTranslation();

    return (
      <Container>
        <StepCard>
          <StepIcon>
            <SVG height={76} accessibilityLabel={'STEP 1'} image={TransferIcon} />
          </StepIcon>
          <StepContent>
            <StepText>{t(step1)}</StepText>
            <StepNumber>1</StepNumber>
          </StepContent>
        </StepCard>

        <StepCard>
          <StepIcon>
            <SVG height={76} accessibilityLabel={'STEP 2'} image={EnvelopeIcon} />
          </StepIcon>
          <StepContent>
            <StepText>{t(step2)}</StepText>
            <StepNumber>2</StepNumber>
          </StepContent>
        </StepCard>

        {withFieldInstructions && (
          <InputFieldsSection>
            <InputField>
              <FieldLabel>Sender Bank Name</FieldLabel>
            </InputField>
            <InputField>
              <FieldLabel>MXN Amount received</FieldLabel>
            </InputField>
            <InputField>
              <FieldLabel>
                Clave de Rastreo <FieldSubtext>(Tracking Key reference number)</FieldSubtext>
              </FieldLabel>
            </InputField>
          </InputFieldsSection>
        )}
      </Container>
    );
  },
);

export default FrictionlessAfterFormSpecialComponent;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  border-radius: 8px;
`;

const StepCard = styled.div`
  display: flex;
  align-items: center;
  background-color: #f5f6fa;
  border-radius: 12px;
  padding: 20px;
  // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  gap: 16px;
`;

const StepIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 8px;
  background-color: #e3f2fd;
`;

const StepContent = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  gap: 16px;
`;

const StepNumber = styled.div`
  font-size: 48px;
  font-weight: 600;
  color: #bdbdbd;
  line-height: 1;
  margin-left: 80px;
`;

const StepText = styled.p`
  flex: 1;
  margin: 0;
  color: #333;
  font-size: 16px;
  line-height: 1.5;
`;

const InputFieldsSection = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 12px;
  background-color: #f5f6fa;
  border-left: 5px solid #03adef;
  padding: 16px;
  margin-top: -20px;
`;

const InputField = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  padding: 16px;
`;

const FieldLabel = styled.div`
  color: #333;
  font-size: 14px;
  font-weight: 500;
`;

const FieldSubtext = styled.span`
  color: #666;
  font-size: 12px;
  font-weight: normal;
`;
